import styled, { css } from 'styled-components';
import { calculateGridItemChildWidth } from '../../../commonStyles/innerGridItemColumn';
import fonts from '../../../helpers/fonts';
import mediaQuery, { stylePerBreakpoint } from '../../../helpers/mediaQuery';
import spacing from '../../../helpers/spacing';
import fluidGridColumns from '../../../theme/fluidGridColumns';
import { PrimaryCta, SecondaryCta } from '../../Cta';
import { Grid } from '../../Grid';
import { finePrintWidthInColumns, marketingPromoCopyGridProps } from './layout';

export const StyledGrid = styled(Grid)`
  padding: ${spacing(4)} 0;
`;

export const Heading = styled.h3`
  ${fonts.headingMedium};
  margin: ${spacing(3)} 0 ${spacing(2)};

  ${mediaQuery.tabletPortrait`
    margin-top: 0;
  `}
`;

export const Subheading = styled.p`
  ${fonts.paragraphLarge};
  margin: ${spacing(2)} 0 0;
`;

export const CtasContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  text-align: left;

  margin-left: ${spacing(-2)};
  margin-top: ${spacing(2)};
`;

const ctaStyle = css`
  flex: 0 1 auto;

  margin-left: ${spacing(2)};
  margin-top: ${spacing(2)};
  min-width: unset;
`;

export const StyledSecondaryCta = styled(SecondaryCta)`
  ${ctaStyle};
`;

export const StyledPrimaryCta = styled(PrimaryCta)`
  ${ctaStyle};
`;

export const FinePrint = styled.div`
  ${fonts.paragraphSmall}
  margin-top: ${spacing(4)};

  ${mediaQuery.tabletLandscape`
    margin-bottom: ${spacing(2)};
  `}

  /*  We don't want to display the fine print across the full banner for the wider breakpoints, to follow
      best practices for long copy
  */
 ${stylePerBreakpoint(
   (breakpoint) => css`
     width: ${calculateGridItemChildWidth(
       marketingPromoCopyGridProps[breakpoint] ?? fluidGridColumns[breakpoint],
       finePrintWidthInColumns[breakpoint] ?? fluidGridColumns[breakpoint],
       breakpoint
     )};
   `
 )}
`;
